module.exports = __webpack_public_path__ + "img/logofull.23f1169d.png";